import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
 
@Injectable({
  providedIn: 'root',
})

export class ConsumerDetailsResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private homeService:HomeService, private auth:AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    const user = await this.auth.getUser()
    const profileId = route.paramMap.get('profileId') || user.uid;
    const role = route.data.role||'consumer';
    const newItem = <ProfileModel>{
      status:'new',
      key: profileId,
      role:role,
      details:{
        role:role,
        geocoding:{
          address:{
            postalCode:null,
            countryCode:null,
            city:null,
            houseNumber:null,
          }
        },
        fullProfile:false,
        shortDetails:{
          name:null
        },
        fullDetails:{
          firstname:null,
          lastname:null,
          phone:null
        }
      },
      private:{
        notifications:{
          newTournee:{
            email:true,
            app:true,
          }
        }
      }
    };
    if(!profileId || !user.uid){
      console.log('no ids');
      this.homeService.navigateToHome('unknown');
    }
    else{
      const item = await firstValueFrom(this.dataService.getConsumerDetails(profileId));
      if (item && Object.keys(item).length>0) {
        const consumer:ProfileModel = {
          key:profileId,
          role:role,
          details:item
        }
        console.log('consumer found',consumer);
        return consumer;
      } else { // id not found, user exists but consumer not yet
        console.log('consumer not found', item);
        return newItem;
      }
    }
  }
}